<div class="width-full">
	<section [ngClass]="styles.sectionWrapper">
		<div [ngClass]="styles.title">{{webcast.title}}</div>
		<div [ngClass]="styles.metaLine">{{webcast.startDate| vbDateTimeMedium}} - {{webcast.endDate| vbDateTimeMedium}}</div>
		<div *ngIf="webcastViewContext.infoSidebar.showHostName" [ngClass]="styles.metaLine">{{ 'Host' | translate }}: {{ webcast.eventHostFullName }}</div>
	</section>

	<section *ngIf="webcastViewContext.infoSidebar.showSharingUrl && !webcast.hideShareUrl" [ngClass]="styles.sectionWrapper">
		<div [ngClass]="styles.sectionHeader">{{ 'Event_Webcast_InvitationJoinMsg' | translate }}</div>
		<div [ngClass]="styles.linkInfo">
			<a class="text-decoration-underline theme-primary-font-link fw-bold" [href]="eventUrl" target="_blank">{{ eventUrl }}</a>

			<p [hidden]="!webcast.password" [ngClass]="styles.infoLine">
				<span>{{ 'Password' | translate }}:</span>
				{{ webcast.password }}
			</p>

			<p *ngIf="webcast.isProducerEvent" [ngClass]="styles.infoLine">
				<span>{{ 'Reminder_Title' | translate }}:</span>
				{{ 'Event_Producer_LinkReminder' | translate }}
			</p>
		</div>
	</section>
	<section *ngIf="webcastViewContext.infoSidebar.showPPDownload && webcast.canDownloadPresentationFile" [ngClass]="styles.sectionWrapper">
		<div [ngClass]="styles.sectionHeader">{{ 'Event_PresentationFileDownloadLink' | translate }}</div>
			<a [ngClass]="styles.supplementalContentItem" class="theme-primary-txt" download layout layout-wrap="false" [href]="webcast.presentation.downloadUrl">
					<span class="glyphicons filetype ppt theme-primary-txt" [ngClass]="styles.fileIcon">
					</span>
					<div flex="fill">
						<span class="supplemental-content-title">{{webcast.presentation.name}}</span>
					</div>
			</a>
	</section>

	<section [ngClass]="[styles.sectionWrapper, styles.description]" class="theme-primary-font-border-fade-50" [hidden]="!(webcast.description)">
		<div [ngClass]="styles.sectionHeader">{{ 'Description' | translate }}:</div>
		<vb-ui-toggle-content-display [minHeight]="200">
			<div #vbUiToggleItem class="user-content" [innerHTML]="webcast.description | safeHtml"></div>
		</vb-ui-toggle-content-display>
	</section>
</div>
